import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MainView } from "./components/main-view";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <MainView />
  </BrowserRouter>
);
